"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adjectives = [
    "big",
    "blue",
    "brave",
    "breezy",
    "bright",
    "calm",
    "chatty",
    "chilly",
    "clever",
    "cuddly",
    "curly",
    "dangerous",
    "dry",
    "evil",
    "fast",
    "fluffy",
    "fresh",
    "friendly",
    "funny",
    "fuzzy",
    "gentle",
    "giant",
    "good",
    "great",
    "green",
    "happy",
    "heavy",
    "honest",
    "hot",
    "hungry",
    "jolly",
    "kind",
    "light",
    "little",
    "loud",
    "lovely",
    "lucky",
    "mean",
    "mighty",
    "modern",
    "neat",
    "new",
    "nice",
    "orange",
    "perfect",
    "pink",
    "polite",
    "popular",
    "pretty",
    "proud",
    "purple",
    "quick",
    "quiet",
    "rare",
    "red",
    "sharp",
    "short",
    "shy",
    "silent",
    "silly",
    "smart",
    "smooth",
    "soft",
    "spicy",
    "splendid",
    "spotty",
    "strong",
    "sweet",
    "swift",
    "tall",
    "tame",
    "tasty",
    "tender",
    "thin",
    "tidy",
    "tiny",
    "tricky",
    "warm",
    "wise",
    "witty",
    "wonderful",
    "yellow",
    "whacky",
];
exports.default = adjectives;
//# sourceMappingURL=adjectives.js.map